import { ChangeDetectionStrategy, Component, computed, inject, input, untracked } from '@angular/core';
import { BillingPeriod } from '@dss-libs/portal/type/portal-types';
import { ChargebeeFacadeService, PaymentService } from '@dss-libs/portal/data-access/payment';
import { ClientService } from '@dss-libs/shared/data-access/clients';
import { BaseModalComponent } from '@dss-libs/shared/ui/common-components';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'dss-libs-feature-payment-plans',
  imports: [BaseModalComponent, TranslocoDirective, TranslocoCurrencyPipe],
  templateUrl: './payment-plans.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './payment-plans.component.css',
})
export class PaymentPlansComponent {
  readonly #paymentService = inject(PaymentService);
  readonly #chargebeeFacadeService = inject(ChargebeeFacadeService);
  readonly #clientService = inject(ClientService);

  readonly planId = input<string>();

  dynamicPlanId: string | null = null;
  selectedPlanBillingPeriod = BillingPeriod.Month;
  selectedPlanId: string | null = null;

  readonly showPlansModal = computed(() => {
    if (this.planId() && this.#clientService.showSubscriptionModal()) {
      untracked(() => {
        this.selectedPlanId = this.planId()!;
        this.confirmAndCloseTermsModal();
      });
      return false;
    }
    return this.#clientService.showSubscriptionModal();
  });

  readonly subscriptionPlansResource = this.#paymentService.subscriptionPlansResource(this.showPlansModal);
  readonly subscriptionPlans = computed(() =>
    this.subscriptionPlansResource.hasValue() ? this.subscriptionPlansResource.value() : []
  );

  constructor() {
    this.#chargebeeFacadeService.initializeChargebee();
  }

  fireDropInScript() {
    this.dynamicPlanId = this.planId() || this.selectedPlanId;
    this.#chargebeeFacadeService.fireDropInScript(this.dynamicPlanId!, this.#clientService.tokenData.email);
  }

  closePlansModal() {
    this.#clientService.showSubscriptionModal.set(false);
  }

  selectPlanBillingPeriod(billingPeriod: BillingPeriod) {
    this.selectedPlanBillingPeriod = billingPeriod;
  }

  confirmAndCloseTermsModal() {
    this.closePlansModal();
    this.fireDropInScript();
  }

  selectPlan(id: string) {
    this.selectedPlanId = id;
    this.confirmAndCloseTermsModal();
  }

  protected readonly BillingPeriod = BillingPeriod;
}
